export enum OTPMethod {
    SMS = 'SMS',
    ZALO = 'ZALO',
    EMAIL = 'EMAIL',
}
